import { formatRupeeLabel } from '../../../../display-values/lumpsumPlanAmount'
import {
  isIdealPlansFetchFailed,
  isIdealPlansLoading,
  useLumpsumPlansContext
} from '../../LumpsumPlansProvider'
import { PlansPlanMode } from '../../../api/types'
import { isIdealPlansListFullyEmpty } from '../../../../utils/lumpsum/planListUtils'

export const LUMPSUM_IDEAL_CONTEXT_CLASS_NAME = 'relative z-[1] px-5 pb-6'

export function LumpsumIdealContextBar() {
  const { idealData, idealPlansQuery } = useLumpsumPlansContext()
  const isHeaderLoading = isIdealPlansLoading(
    PlansPlanMode.IDEAL_PORTFOLIO,
    idealData != null,
    idealPlansQuery
  )
  const isPlansEmpty = !isHeaderLoading && isIdealPlansListFullyEmpty(idealData?.categories)
  const isPlansFetchFailed = isIdealPlansFetchFailed(PlansPlanMode.IDEAL_PORTFOLIO, idealPlansQuery)
  const portfolioValue = idealData?.idealPortfolioValue ?? 0

  if (isHeaderLoading || isPlansEmpty || isPlansFetchFailed || portfolioValue <= 0) {
    return null
  }

  return (
    <div className={LUMPSUM_IDEAL_CONTEXT_CLASS_NAME} data-lumpsum-plans-ideal-context>
      <div className="text-[13px] leading-[150%] text-[#6A6E6E] pt-3">
        <span className="font-[500] text-[#232323]">
          Taking{' '}
          {formatRupeeLabel({ rawAmount: portfolioValue })}
        </span>{' '}
        approx portfolio value
      </div>
    </div>
  )
}
